import React from 'react';
import Image from 'next/image';
import Section from './Section';
import { ABOUT_ME_EN } from './index';
import AdviceAvatar from '@/assets/resume-advice/advice-avatar.png';

const AboutMeAdvice = () => {
  const [selectedTitle, setSelectedTitle] = React.useState('');

  return (
    <ul className="m-0 list-none">
      <Section
        title="三大要素打造令人印象深刻的“个人总结”"
        adviceIndex={1}
        selectedTitle={selectedTitle}
        setSelectedTitle={setSelectedTitle}
        link="https://www.tanzhi.cn/articles/resume-advice-about-me-2/"
        sectionGroup={ABOUT_ME_EN}
        isRecommend={true}
        defaultChecked={true}
      >
        <div className="bg-green-50 px-3 py-4 rounded-lg flex mb-8">
          <Image
            className="shrink-0"
            src={AdviceAvatar}
            alt=""
            style={{ width: 24, height: 24 }}
          />
          <span className="text-green-700 font-semibold ml-2">
            三要素：职业定位、核心经历或能力、求职意向
          </span>
          <span className="ml-auto shrink-0 self-center">👍 12</span>
        </div>
        <div className="leading-6.5 text-black/85">
          <p className="mb-2">
            “个人总结”模块在简历中的作用是用几行文字突出你的职业定位，并初步塑造职业形象。为了让这个部分令人印象深刻，可以从以下三个方面来构建内容：
          </p>
          <ul className="m-0 list-none">
            <li className="mb-2">
              <strong>要素1：职业定位</strong>
              <ul className="!ml-12 list-disc">
                <li>
                  用一句话总结你的主要职业定位。这个定位应当明确且具有针对性，能够让用人单位快速理解你希望从事的工作类型。例如：“作为一名数据分析师，我专注于利用大数据来推动业务决策和优化。
                </li>
              </ul>
            </li>
            <li className="mb-2">
              <strong>要素2：核心经历或能力</strong>
              <ul className="!ml-5 list-disc">
                <li>
                  用少数几句话概括你的主要经历和通过这些经历获得的核心能力。这里要展示如何通过过去的经历支持你的职业定位。例如：“在过去的三年里，我在一家跨国公司担任数据分析师，成功实施了多个数据驱动的项目，显著提高了业务运营效率。”
                </li>
              </ul>
            </li>
            <li className="mb-2">
              <strong>要素3：求职意向</strong>
              <ul className="!ml-5 list-disc">
                <li>
                  明确表达你希望进入的求职环境或领域。这帮助用人单位了解你的职业目标和你所期望的工作类型。例如：“我目前寻求在快速发展的科技公司中担任高级数据分析师一职，以进一步提升我的数据分析能力和业务洞察力。“
                </li>
              </ul>
            </li>
            <li>
              <strong>小贴士：</strong>
              <ul className="!ml-5 list-disc">
                <li>
                  <strong>突出职业定位：</strong>
                  职业定位要明确，不要加入过多细节。主要定位应当一目了然，不需要在这一部分展开过多背景细节。例如：“作为一名市场营销专家，我在数字营销策略制定和执行方面具有深厚的经验。”
                </li>
                <li>
                  <strong>文字精炼：</strong>
                  保持语言精炼干练。一般来说，“个人总结”模块应在3-4行之间，超过6行可能会显得过于冗长。保持简洁有助于突出重点，不让用人单位感到信息过载。
                </li>
                <li>
                  <strong>真实和诚恳：</strong>
                  内容要源自你的真实想法，反映你对职业定位的实际理解和下一步发展的计划，避免使用套话或模糊的描述。
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </Section>
      <Section
        title="如何在“个人总结”中简明表达职业定位？"
        adviceIndex={2}
        selectedTitle={selectedTitle}
        setSelectedTitle={setSelectedTitle}
        link="https://www.tanzhi.cn/articles/resume-advice-about-me-3/"
        sectionGroup={ABOUT_ME_EN}
        isRecommend={true}
      >
        <p className="mb-3">方法：</p>
        <div className="bg-green-50 px-3 py-4 rounded-lg flex mb-8">
          <Image
            className="shrink-0"
            src={AdviceAvatar}
            alt=""
            style={{ width: 24, height: 24 }}
          />
          <ul className="text-green-700 px-1 ml-5 leading-6">
            <li>
              <strong>首先明确职场角色：</strong>
              职业定位应体现你在职场中的明确角色，它代表你对自身角色定位的理解;
            </li>
            <li>
              <strong>其次匹配职业成长轨迹：</strong>
              职业定位应与个人的职业成长轨迹高度一致，并反映你希望在职场上发展的方向。
            </li>
          </ul>
          <span className="ml-auto shrink-0 self-center">👍 12</span>
        </div>
        <p className="mb-3">示例：</p>
        <div className="border border-[#219653] border-dashed p-4 rounded-lg mb-8 text-black/85">
          <p className="font-semibold mb-3">
            “我是一名拥有硕士学位和七年丰富经验的专业人士。”
          </p>
          <ul className="ml-6 leading-6.5">
            <li className="mb-3">
              <strong>分析：</strong>
              该描述过于笼统，缺乏明确的职场角色，“专业人士”并不能让用人单位清晰地理解你的职场定位。此外，学位和经验在简历的其他部分已经明确表达，不需要在这里重复强调。
            </li>
            <li>
              <strong>优化后的描述：</strong>
              “我是一名具有全栈研发经验的产品经理，擅长设计和研发数据系统的核心功能模块和平台架构。”
            </li>
          </ul>
        </div>
        <p className="text-black/65 leading-6.5">
          总结：在简历的“个人总结”模块中，准确地描述职业定位可以帮助用人单位迅速理解你的职场角色和职业方向。确保你的定位描述符合以上两个准则——明确的职场角色和与职业成长轨迹相符——能够使你的职业形象更加清晰和有力。
        </p>
      </Section>
      <Section
        title="如何在“个人总结”模块中清晰呈现过往经验？"
        adviceIndex={3}
        selectedTitle={selectedTitle}
        setSelectedTitle={setSelectedTitle}
        link="https://www.tanzhi.cn/articles/resume-advice-about-me-4/"
        sectionGroup={ABOUT_ME_EN}
        isRecommend={true}
      >
        <p className="mb-3">方法：</p>
        <div className="bg-green-50 px-3 py-4 rounded-lg flex mb-2">
          <Image
            className="shrink-0"
            src={AdviceAvatar}
            alt=""
            style={{ width: 24, height: 24 }}
          />
          <span className="text-green-700 font-semibold ml-2">
            根据你的职业定位对过往经验做些许的精炼和拔高。
          </span>
          <span className="ml-auto shrink-0 self-center">👍 12</span>
        </div>
        <p className="mb-8 leading-6.5 text-green-900/70">
          <strong>精炼</strong>是指将繁杂的经历浓缩为几句核心内容，而
          <strong>拔高</strong>
          则意味着从更高的视角总结经验，以突出与你当前职业定位相关的关键能力。
        </p>
        <p className="mb-3">示例：</p>
        <div className="border border-[#219653] border-dashed p-4 rounded-lg mb-8 text-black/85">
          <ul className="ml-6 leading-6.5">
            <li className="mb-3">
              <strong>职业定位：</strong>
              “作为一名在海内外拥有丰富经验的毕业生，我具有出色的跨文化协作能力和问题解决能力。”
            </li>
            <li className="mb-3">
              <strong>作为支撑的经历：</strong>
              “我在多个跨国团队中有过实习经验，积累了丰富的数据处理和可视化的经验，并且有将数据结论应用到营销领域的成功案例。我可以熟练的使用
              SQL、Python 等工具进行数据处理和分析，以及使用 R、Power BI 和
              Excel 进行数据可视化。”
            </li>
            <li>
              <strong>分析：</strong>
              这个描述没有重复列出具体的公司或职位，而是直接对与职业定位相关的核心能力进行概括和高亮，确保用人单位能够迅速理解这些能力如何支撑你的职业角色。
            </li>
          </ul>
        </div>
        <p className="mb-3">总结：</p>
        <ul className="ml-6 leading-6.5 text-black/85">
          <li className="mb-3">
            <strong>简短有力：</strong>
            避免在“个人总结”模块中重复详细的工作经历，而是提炼出核心能力。
          </li>
          <li className="mb-3">
            <strong>围绕职业定位：</strong>
            确保所有提到的经历都直接支撑你的职业定位，形成清晰的脉络。
          </li>
          <li>
            <strong>避免冗余信息：</strong>
            不需要列出每一个职位或详细的技能，重点展示与职业定位直接相关的经验和能力。
          </li>
        </ul>
      </Section>
      <Section
        title="如何在“个人总结”中精准传达求职意向？"
        adviceIndex={4}
        selectedTitle={selectedTitle}
        setSelectedTitle={setSelectedTitle}
        link="https://www.tanzhi.cn/articles/resume-advice-about-me-5/"
        sectionGroup={ABOUT_ME_EN}
        isRecommend={true}
      >
        <p className="mb-3">方法：</p>
        <div className="bg-green-50 px-3 py-4 rounded-lg flex mb-8">
          <Image
            className="shrink-0"
            src={AdviceAvatar}
            alt=""
            style={{ width: 24, height: 24 }}
          />
          <span className="text-green-700 font-semibold ml-2">
            首先表达职能和角色；其次确定领域和行业; 最后描述工作环境和文化偏好
          </span>
          <span className="ml-auto shrink-0 self-center">👍 12</span>
        </div>
        <p className="mb-3">示例：</p>
        <div className="border border-[#219653] border-dashed p-4 rounded-lg mb-3 text-black/85 leading-6.5">
          <p className="mb-3">
            对于职场新人或应届生，如果你的职业目标尚未完全定型，可以采用较为概括性的表达方式。
          </p>
          <p className="font-semibold mb-3">
            例如：“我的职业目标是成为技术与产品、营销之间的桥梁，为企业提供数据驱动的洞察和策略，推动业务增长。”
          </p>
          <ul className="ml-6">
            <li className="mb-3">
              <strong>分析：</strong>
              这个表达方式展示了你希望在职场中扮演的角色，突出了你的综合能力，适合那些还没有完全确定职位方向的求职者。
            </li>
          </ul>
        </div>
        <div className="border border-[#219653] border-dashed p-4 rounded-lg text-black/85 leading-6.5">
          <p className="mb-3">
            对于有一定职场经验的求职者，求职意向应更加明确，结合具体的职位角色来表达：
          </p>
          <p className="font-semibold mb-3">
            例如：“期望作为品牌经理在美妆领域承担更多挑战。”
          </p>
          <ul className="ml-6">
            <li className="mb-3">
              <strong>分析：</strong>
              这里明确了你希望从事的职位和行业领域，表明了你在职业发展中的具体方向，这种表达更适合已经有一定经验的求职者。
            </li>
          </ul>
        </div>
      </Section>
      <Section
        title="为什么“个人总结”模块至关重要？"
        adviceIndex={5}
        selectedTitle={selectedTitle}
        setSelectedTitle={setSelectedTitle}
        link="https://www.tanzhi.cn/articles/resume-advice-about-me-1/"
        sectionGroup={ABOUT_ME_EN}
      >
        <ul className="!ml-5 list-disc leading-6.5 text-black/85">
          <li className="mb-4">
            <strong>具备个人特色的职业定位展示：</strong>
            <ul className="!ml-5 list-disc">
              <li>
                “个人总结”模块是简历的开头部分，用于从个人视角出发，阐述你对职业定位的理解、经历概览以及求职意向。它的主观性很强，能够展示你希望塑造的职业形象。
              </li>
            </ul>
          </li>
          <li className="mb-4">
            <strong>明确职业形象：</strong>
            <ul className="!ml-5 list-disc">
              <li>
                职业定位和求职意向：这个部分帮助用人单位快速了解你是谁、做过什么、想做什么。明确的职业定位和清晰的求职意向可以帮助用人单位更好地理解你是否适合目标岗位。
              </li>
            </ul>
          </li>
          <li className="mb-4">
            <strong>引导用人单位的印象：</strong>
            <ul className="!ml-5 list-disc">
              <li>
                第一印象的重要性：通过“个人总结”模块设定的第一印象将影响用人单位对你后续经历的解读。如果你在这部分中明确了你的职业形象和目标，用人单位在阅读剩余的简历时会带着这个视角来审视你的经历。
              </li>
            </ul>
          </li>
          <li className="mb-4">
            <strong>避免简历的单调性：</strong>
            <ul className="!ml-5 list-disc">
              <li>
                增添生动性：缺少“个人总结”模块的简历可能会显得单调乏味，因为简历中的内容全是客观的经历素材。这个模块通过个人化的描述，为简历增添了个性和生动性。
              </li>
            </ul>
          </li>
          <li>
            <strong>整体印象的提升：</strong>
            <ul className="!ml-5 list-disc">
              <li>
                建立整体印象：一个清晰的“个人总结”模块可以帮助用人单位更好地建立对你的整体印象，从而在初筛阶段更容易获得青睐。它展示了你的职业定位和个人特点，使简历更加引人注目。
              </li>
            </ul>
          </li>
        </ul>
      </Section>
      <Section
        title="求职意向太明确会影响求职机会吗？"
        adviceIndex={6}
        selectedTitle={selectedTitle}
        setSelectedTitle={setSelectedTitle}
        link="https://www.tanzhi.cn/articles/resume-advice-about-me-6/"
        sectionGroup={ABOUT_ME_EN}
      >
        <p className="mb-3">答案：</p>
        <div className="bg-green-50 px-3 py-4 rounded-lg flex mb-8">
          <Image
            className="shrink-0"
            src={AdviceAvatar}
            alt=""
            style={{ width: 24, height: 24 }}
          />
          <span className="text-green-700 font-semibold ml-2">
            明确的求职意向会提高工作机会匹配的上限
          </span>
          <span className="ml-auto shrink-0 self-center">👍 12</span>
        </div>
        <ul className="!ml-5 list-disc leading-6.5 text-black/85">
          <li className="mb-4">
            <strong>提高机会匹配的上限：</strong>
            <ul className="!ml-5 list-disc">
              <li>
                如果你的期望与公司的需求高度一致，这会为你加分，并可能使你在竞争中脱颖而出。
              </li>
            </ul>
          </li>
          <li className="mb-4">
            <strong>不会降低机会的下限：</strong>
            <ul className="!ml-5 list-disc">
              <li>
                即便你的求职意向与职位要求有些偏差，只要你的整体条件符合职位需求，招聘者依然可能会联系你。
              </li>
              <li>
                明确的求职意向还能传递你对工作的期望，有助于在后续的面试中建立起对话的基础。
              </li>
            </ul>
          </li>
          <li>
            <strong>建立心理锚定标准：</strong>
            <ul className="!ml-5 list-disc">
              <li>
                表达明确的求职意向也有助于建立一个心理锚定标准，帮助招聘者了解你的职业方向和期望。这不仅有助于匹配合适的职位，还可以在面试中帮助双方更好地沟通和理解彼此的期望。
              </li>
            </ul>
          </li>
        </ul>
      </Section>
      <Section
        title="“个人总结”与“个人优势”：你该写哪一个？"
        adviceIndex={7}
        selectedTitle={selectedTitle}
        setSelectedTitle={setSelectedTitle}
        link="https://www.tanzhi.cn/articles/resume-advice-about-me-7/"
        sectionGroup={ABOUT_ME_EN}
      >
        <ul className="!ml-5 list-disc leading-6.5 text-black/85">
          <li className="mb-4">
            <strong>“个人总结” vs “个人优势”两种叙述方式的区别</strong>
            <ul className="!ml-5 list-disc">
              <li>
                个人总结：
                <ul className="!ml-5 list-disc">
                  <li>展示职业定位：明确你是谁，你的职业目标是什么。</li>
                  <li>
                    塑造职业形象：通过叙述让用人单位对你产生一个清晰的初步印象。
                  </li>
                  <li>引导阅读视角：不断强化对你职业形象的理解。</li>
                </ul>
              </li>
              <li>
                个人优势：
                <ul className="!ml-5 list-disc">
                  <li>
                    技能列表：列出你掌握的关键技能，如“熟练使用Excel”、“团队协作能力强”等
                  </li>
                  <li>经验概述：简要提及你在哪些方面有经验，但不深入。</li>
                </ul>
              </li>
            </ul>
          </li>
          <li>
            <strong>为什么更推荐“个人总结”式的叙述方式</strong>
            <ul className="!ml-5 list-disc">
              <li>
                <strong>更具主观性和连贯性：</strong>
                “个人总结”能够更好地将你的职业定位和个人形象整合到一起。这种叙述方式不仅展现了你的能力，更传递了你对职业发展的理解和目标。
              </li>
              <li>
                <strong>强化职业形象：</strong>
                通过“个人总结”，你可以在简历的开篇就明确传达你的职业形象。用人单位在阅读你后续的经历描述时，会不自觉地从你塑造的形象出发去理解和评价你的能力和经历。
              </li>
              <li>
                <strong>引导阅读体验：</strong>
                “个人总结”可以帮助用人单位带着一个清晰的职业形象进入后续内容的阅读，这种持续的形象强化能让你的简历在众多求职者中脱颖而出。
              </li>
            </ul>
          </li>
        </ul>
      </Section>
    </ul>
  );
};

export default AboutMeAdvice;
